import { WorkflowAction } from '../models/workflow-action';
import { WorkflowActionProperty } from '../../../models';
import { Mapper } from '../../../mappers';

export class WorkflowActionMapper extends Mapper<
  WorkflowAction[],
  WorkflowActionProperty[]
> {
  from(source: WorkflowAction[]): WorkflowActionProperty[] {
    return source.map(
      (item) =>
        ({
          key: item.Key,
          parentWorkflowKey: item.ParentWorkflowKey,
          action: item.Action,
          conditions: item.Conditions,
          operations:
            item.Operations?.map((operation) => ({
              type: operation.Type,
              data: operation.Data,
              fieldName: operation.FieldName ?? null,
            })) ?? [],
        }) as WorkflowActionProperty,
    );
  }
}
